var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"button-text":_vm.tokens.newDesign.confirmWithdrawal,"button-style":'filled-primary',"disabled":_vm.disabled},nativeOn:{"click":function($event){return _vm.requestWithdrawal.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }